export default __webpack_public_path__ + "static/media/rp_hall.3f53ffa4.PNG";